<div class="footer__block">
  <div class="footer__heading heading heading_small">Company</div>
  <div class="footer__links">
    <a routerLink="/about">About</a>
    <a routerLink="/faq">FAQ</a>
    @if (false) {
      <a routerLink="/plans">Plans</a>
    }
    <a routerLink="/contacts">Contacts</a>
  </div>
  <div class="footer__social">
    <app-social-links classes="social_footer" />
  </div>
</div>
